import { useState, useEffect } from 'react';
import { Tabs, Space, Table } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Print, Save, SwipeUp, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../InputT';
import Tab2 from './Tab2';
import { useForm } from 'react-hook-form';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import Pret from '../../../../Models/Pret';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import useEcheancierPret, { echeancierColumns, totauxFormFields } from '../../../../Hooks/useEcheancierPret';
import PrintTabAmort from '../../../Prints/PrintTabAmort';
import VersionEcheancierSelect from '../VersionEcheancierSelect';
//import "../../Assets/Styles/StyleForm.css";



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const Simulation = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState<any[]>([])
  const [printOpen, setPrintOpen] = useState(false)
  const [printCtx, setPrintCtx] = useState<{ numDos?: string, form?: any }>({})
  const { charger, afficherVersion, versions, version, loading: loadingEcheancier } = useEcheancierPret()


  const ThemeTable = styled(Table)(({ theme }) => ({

    ".ant-table-body ": {
      height: '185px',
      borderBottom: '1px var(--colorOpaque020) solid',
    }

  }
  ));




  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    //form.resetFields()
  }

  const columns: ColumnsType<any> = echeancierColumns;

  //  : number,
  //  : number,
  // montantTA : number,
  // echeancierPlusTA : number,
  //  : number,
  // echeancierTot : number,
  //  : Date

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }



  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    setImpActive(true)
    setData([])
    form.resetFields()
    localStorage.clear()
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Information prêt
        </span>
      ),
      children: <Tab1 form={form} disabled={ajoutActve} />, //form={form}
    },
    {
      key: '2',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Commission
        </span>
      ),
      children: <Tab2 form={form} />, //form={form}
    }
  ];

  const affiche = async () => {
    let numSimul = form.getFieldValue("NUMSIMUL")

    if (!numSimul) {
      SweetAlert.fire({ title: "Enregistrez ou consultez d'abord une simulation pour afficher son échéancier.", icon: "warning" })
      return
    }

    const result = await charger(numSimul, 'SIMULATION')
    
    if (result) {
      setData(result.echeances)
      form.setFieldsValue(totauxFormFields(result.totaux))
      setImpActive(false)
    } else {
      SweetAlert.fire({ title: "Aucun échéancier trouvé pour cette simulation.", icon: "warning" })
    }
  };


  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };


  function printTab() {
    const numSimul = form.getFieldValue("NUMSIMUL")
    if (!numSimul) {
      SweetAlert.fire({ title: "Enregistrez ou consultez d'abord une simulation pour imprimer son échéancier.", icon: "warning" })
      return
    }
    // L'aperçu modal recharge l'échéancier persisté depuis la base.
    setPrintCtx({ numDos: numSimul, form: { ...form.getFieldsValue(), titre: "SIMULATION TABLEAU D'AMORTISSEMENT N°" + numSimul } })
    setPrintOpen(true)
  }

  const onFinish = (values: any) => {
    if (sbmit == "add") {
      SweetAlert.fire({
        title: "Enregistrement de la simulation de pret",
        text: "Voulez-vous enregistrer cette simulation de crédit?",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)
          //alert(JSON.stringify(values))

          let pret : Pret = values
          pret.UTILISAI = user.coduti
          pret.AGCCPT = user.codage
          pret.DATEDEM = formatDate(pret.DAT1ECHE)
          pret.DAT1ECHE = formatDate(pret.DAT1ECHE)
          pret.NOMCLI = values.lib_NUMCLI
          pret.fraiservi = values.cssionApliq 
          //alert(pret.NOMCLI)
          let data = Crypter.encrypt(JSON.stringify(pret));

          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.CreateSimulationPret,
            headers: {
              //'CypherUser': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode == 200) {
                  let code = values.CODUTI
                  form.resetFields()
                  localStorage.clear()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Message, icon: "success" })
                  initialiazeButton()
                  localStorage.setItem(Data.LocalVariable.reset, "1")

                  setSbmit("")

                  // L'échéancier a été généré en base par la procédure stockée :
                  // on le recharge pour consultation.
                  try {
                    const numSimul = res.Result?.Table?.[0]?.NUMSIMUL ?? res.Result?.Table?.[0]?.NUMDOS ?? values.NUMSIMUL
                    if (numSimul) {
                      charger(numSimul, 'SIMULATION').then((r) => {
                        if (r) {
                          setData(r.echeances)
                          form.setFieldsValue(totauxFormFields(r.totaux))
                          setImpActive(false)
                        }
                      })
                    }
                  } catch (e) { }
                }
                else {
                  SweetAlert.fire({ title: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            });

        }
      })
    }
    if (sbmit == "update") {
      //console.log(values)
      SweetAlert.fire({
        title: "Voulez-vous modifier la simulation de pret " + values.NUMSIMUL + " ?",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)

          let pret : Pret = values
          pret.UTILISAI = user.coduti
          pret.AGCCPT = user.codage
          pret.DATEDEM = formatDate(pret.DAT1ECHE)
          pret.DAT1ECHE = formatDate(pret.DAT1ECHE)
          pret.NOMCLI = values.lib_NUMCLI
          pret.fraiservi = values.cssionApliq 
          pret.NUMDOS = values.NUMSIMUL

          let data = Crypter.encrypt(JSON.stringify(pret));

          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.UpdateSimulationPret,
            headers: {
              //'CypherUser': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode == 200) {
                  let code = values.CODUTI
                  form.resetFields()
                  localStorage.clear()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Message, icon: "success" })
                  initialiazeButton()
                  localStorage.setItem(Data.LocalVariable.reset, "1")

                  setSbmit("")

                  // L'échéancier a été généré en base par la procédure stockée :
                  // on le recharge pour consultation.
                  try {
                    const numSimul = res.Result?.Table?.[0]?.NUMSIMUL ?? res.Result?.Table?.[0]?.NUMDOS ?? values.NUMSIMUL
                    if (numSimul) {
                      charger(numSimul, 'SIMULATION').then((r) => {
                        if (r) {
                          setData(r.echeances)
                          form.setFieldsValue(totauxFormFields(r.totaux))
                          setImpActive(false)
                        }
                      })
                    }
                  } catch (e) { }
                }
                else {
                  SweetAlert.fire({ title: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            });
        }
      })
    }
  };
  function modif() {
    modifButton()

  }

  function consult() {
    localStorage.setItem(Data.LocalVariable.reset, "1")
    //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
    let data = Crypter.encrypt(form.getFieldValue("NUMSIMUL"));
    let NUMSIMUL = form.getFieldValue("NUMSIMUL")

    if (data.length != 0) {
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      form.setFieldValue('NUMSIMUL', NUMSIMUL)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetSimulationPret,
        headers: {
          'CypherNumSimul': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            console.log(res)
            if (res.StatutCode == 200) {
              form.setFieldsValue(res.Result.Table[0])
              form.setFieldValue('DATEDEM', ReformatDate(res.Result.Table[0].DATEDEM));
              form.setFieldValue('DAT1ECHE', ReformatDate(res.Result.Table[0].DAT1ECHE));
              //form.setFieldValue('', )

              localStorage.clear()

              //alert(JSON.stringify(res.Result.Table))

              initialiazeButton()

              cunsultButton()
              setEnregActve(false)
              

            }
            else {
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
        });
    }
  }

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>SIMULATION TABLEAU D'AMORTISSEMENT</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>

          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" onClick={affiche} block>
                  Afficher
                </Button>
                <Button size='large' className='bt_add' onClick={printTab} disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
              {/* Sélecteur de version — toujours en haut à gauche du tableau */}
              <Box display={"flex"} justifyContent={"flex-start"} marginBottom={"6px"}>
                <VersionEcheancierSelect
                  versions={versions}
                  version={version}
                  onSelect={(v) => {
                    const r = afficherVersion(v);
                    if (r) {
                      setData(r.echeances);
                      form.setFieldsValue(totauxFormFields(r.totaux));
                    }
                  }}
                />
              </Box>
              <Box display={"flex"} fontStyle="inherit" className='border-left tabElement'>
                <Spin spinning={loading || loadingEcheancier}>
                  <Table size='small' style={{ width: 'auto'}} columns={columns} dataSource={data} scroll={{ y: 200, x: 10 }} pagination={false} />
                </Spin>
              </Box>
              <Box display={"flex"} fontStyle="inherit" className='border-left bordure1 tabElement2'>
                <InputForm notRequired disabled width={8} label='Amort' name='TotAm' type='text' error='mobile' />
                <InputForm notRequired disabled width={8} label='Intéret' name='TotIt' type='text' error='mobile' />
                <InputForm notRequired disabled width={8} label='TVA' name='TotTaxe' type='text' error='mobile' />
                <InputForm notRequired disabled width={8} label='AHT' name='TotAnnuite' type='text' error='mobile' />
                <InputForm notRequired disabled width={8} label='ATTC' name='TotAnTTC' type='text' error='mobile' />
                <InputForm notRequired disabled width={8} label='Epargne' name='TotEpargn' type='text' error='mobile' />
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
      <PrintTabAmort open={printOpen} onClose={() => setPrintOpen(false)} numDos={printCtx.numDos} typeEcp="SIMULATION" form={printCtx.form} />
    </div>
  );
}
export default Simulation;